import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const ROLE_LABELS = {
  admin: "Administrador",
  direcao: "Direção",
  secretaria: "Secretaria",
  professor: "Professor",
  aluno: "Aluno",
  responsavel: "Responsável",
};

export const WRITE_ROLES = ["admin", "direcao", "secretaria"];
export const MANAGE_ROLES = ["admin", "direcao"];

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = verificando, false = não autenticado

  useEffect(() => {
    if (window.location.pathname === "/") {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      // ignore
    }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
